export const ANIMATIONS = {
    PLANTS: {
        PEASHOOTER: {
            idle: {
                key: 'peashooter_idle',
                frameRate: 12,
                frames: { start: 0, end: 7 },
                repeat: -1,
            },
            attack: {
                key: 'peashooter_attack',
                frameRate: 12,
                frames: { start: 8, end: 14 },
                repeat: 0,
            },
        },
        SUNFLOWER: {
            idle: {
                key: 'sunflower_idle',
                frameRate: 12,
                frames: { start: 0, end: 7 },
                repeat: -1,
            },
        },
        WALLNUT: {
            idle: {
                key: 'wallnut_idle',
                frameRate: 12,
                frames: { start: 0, end: 7 },
                repeat: -1,
            },
        },
    },
    ZOMBIES: {
        BASIC: {
            walk: {
                key: 'basic_zombie_walk',
                frameRate: 8,
                frames: { start: 0, end: 11 },
                repeat: -1,
            },
            attack: {
                key: 'basic_zombie_attack',
                frameRate: 8,
                frames: { start: 12, end: 21 },
                repeat: -1,
            },
        },
        CONE: {
            walk: {
                key: 'cone_zombie_walk',
                frameRate: 8,
                frames: { start: 0, end: 14 },
                repeat: -1,
            },
            attack: {
                key: 'cone_zombie_attack',
                frameRate: 10,
                frames: { start: 0, end: 14 },
                repeat: -1,
            },
        },
    },
    EFFECTS: {
        SPLASH: {
            key: 'splash',
            frameRate: 12,
            frames: { start: 0, end: 5 },
            repeat: 0,
        },
    },
};
